<template>
	<div class="parent-div" ref="SMore" >
		<img src="../assets/More.png" :imgId="imgId" v-click-outside="outsideClick" :width="width" :height="height" :class="{more:true, rotate:orientation=='vertical'}"  @click="onClick" :title="tooltip"/>
		<div
        v-if="showOptions"
        class="dropdown-content"
		  :style="setDropdownDesign"
      >
        <ul
          v-for="(option, i) in dropdownOptions"
          :key="i"
          @click="() => emitClickedItem(option)"
        >
          <div :class="{border:i<dropdownOptions.length-1}">
              <li
              :class="{
                dropdownLabel: true,
              }"
              :title="option"
            >
              {{ option }}
            </li>
          </div>
        </ul>
      </div>
	</div>
</template>

<script>
import * as JSFunctions from "../Functions/Functions";

export default {
	name: 'SMore',

	data(){
		return{
      showOptions: false,
      imgId:"",
		}
	},

	props: {
		width: { type: Number, default: 16 },
		height: { type: Number, default: 16 },
    dropdownOptions: { type: Array, required: true },
    tooltip: {Type: String},
    orientation:{
      type: String,
      default: "horizontal"
    }
  },
  created(){
    // console.log(this.$attrs);
    // this.orientation = this.$attrs.orientation;
    this.imgId = JSFunctions.uuid();
  },

	methods: {
		emitClickedItem(name) {
	      // console.log(name)
        this.$emit("clicked-item", name);
        this.showOptions = !this.showOptions
    },

		onClick(){
       this.showOptions = !this.showOptions
       this.$emit("clicked");
    },

    outsideClick(){
      if(this.showOptions === true){
        if(event.target.id === this.imgId){
          this.showOptions = !this.showOptions;
        }
        else{
          if(this.showOptions === true){
            this.showOptions = false;
          }
        }
      }
    },

	},

  watch:{
    orientation: function(nv,ov){
      this.orientation = nv;
    }
  },

	computed: {
		setDropdownDesign(){
			return{
			 	'display': 'block',
				'height': 'max-content'
			}
    },
	}
}
</script>

<style scoped>
.more{
  cursor: pointer;
  opacity: 0.5;
}
.rotate{
  transform:rotate(90deg);
}
.more:hover{
  opacity: 1;
}

.parent-div{
  cursor: pointer;
	/* z-index: 999; */
	position: relative;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #ffffff;
  box-shadow: 0 0 11px 0 #e1e1e1;
  text-align: left;
  margin-top: 2px;
  max-width: 160px;
  z-index: 99;
}

.dropdown-content li {
  list-style: none;
  margin: 0;
  padding: 0px 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

ul {
  padding-left: 0px;
  margin: 0px;
  min-width: 160px;
  background-color: #fff;
}
.border {
  border-bottom: solid 1px #e1e1e1;
}

.dropdownLabel {
    font-family: "Roboto !important";
  font-size: 14px;
  height: 40px;
  margin: 0px;
  line-height: 3;
}

.dropdown-content li:hover {
  background-color: #f4f4f4;
  cursor: pointer;
}

.buttonDiv {
  width: inherit;
  border-bottom: 1px solid #e1e1e154;
}

.onlyBottom {
  width: inherit;
  border-bottom: 1px solid #e1e1e154;
}

</style>